import React, { useEffect, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { IProduct } from '../../../../../types/types';
import Button from '../../../../../../../../generic-components/Button';
import Icon from '../../../../../../../../generic-components/Icon';
import { DownArrow } from '../../../../../../../../assets/svg';

export const itemQuantityTemplate = (item: IProduct, onChange: (item: IProduct) => void) => {
  const [input, setInput] = useState<string>(item.quantity?.toFixed(2));
  useEffect(() => { setInput(item.quantity?.toFixed(2)); }, [item]);
  const handleValueMutate = (type: boolean) => {
    let tempValue = input;
    tempValue = tempValue.replace(/[^0-9.]/g, '');
    if (type) {
      tempValue = (Number(tempValue) + 1).toFixed(2);
    } else {
      tempValue = (Math.max(Number(tempValue) - 1, 0.01)).toFixed(2);
    }
    setInput(tempValue);
    item.quantity = Number(tempValue);
    onChange(item);
  };

  const minQuantity = 0.01;
  const maxQuantity = 10_000;
  const onInputChange = (value: string) => {
    let tempInput = value;
    tempInput = tempInput.replace(/[^0-9.]/g, '');
    const quantity = Number(tempInput);
    if (quantity > maxQuantity) {
      return;
    }
    if (quantity < minQuantity) {
      setInput(tempInput);
      return;
    }
    item.quantity = quantity;
    onChange(item);
    setInput(tempInput);
  };

  return (
    <div className='flex flex-row  h-[64px] px-[4px] hover:bg-bw02'>

      <CurrencyInput
        id='inputInvoiceItemPrice'
        name='input-name'
        className={`w-full text-right pr-[4px] font-metricR text-[14px] text-bw08 outline-none bg-transparent ${item.serviceItemId === undefined ? 'hover:cursor-text' : 'hover:cursor-auto'}`}
        placeholder='0.00'
        value={input}
        decimalsLimit={2}
        prefix=''
        onValueChange={(value) => onInputChange(value || '0.01')}
        onBlur={() => onInputChange(Math.max(Number(input), minQuantity).toFixed(2))}

      />
      <div className='flex flex-col gap-[8px] justify-center '>

        <Button onClick={() => handleValueMutate(true)} className='hover:bg-bw03 rounded-sm p-[4px] h-[16px] w-[16px]' id='quantityUp' childElement={<Icon className='rotate-180 ' src={DownArrow} />} />
        <Button onClick={() => handleValueMutate(false)} className='hover:bg-bw03 rounded-sm p-[4px] h-[16px] w-[16px]' id='quantityDown' childElement={<Icon src={DownArrow} />} />
      </div>
    </div>
  );
};
